const InterviewContent = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6 sm:px-8">
        <div className="bg-white rounded-2xl shadow-[0_4px_24px_rgba(137,181,107,0.15)] p-8 md:p-12">
          <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
            <iframe
              className="absolute inset-0 w-full h-full rounded-xl"
              src="https://www.youtube.com/embed/enDVanHMtfU"
              title="IT社長にアレコレ聞いてみた。(株)MSK 春日啓悟氏"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>

          <div className="mt-10">
            <p className="text-sm text-gray-600 leading-relaxed font-['Noto_Sans_JP']">
              ITなびチャンネルの「IT社長にアレコレ聞いてみた。」に、代表取締役 春日 啓悟が出演しました。<br />
              会社設立の経緯や事業内容、ITへの想いなどについてお話しています。ぜひご覧ください。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InterviewContent;